// ModalPersonalizar con posicionamiento corregido

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector} from "react-redux";
import { personalizarTratamientoBase } from "../../../redux/tratamientos/tratamientosActions";
import { useToasts } from "react-toast-notifications";
import { Modal } from "../../../components/Modal/index";
import { fetchTarifarios } from "../../../services/firebase/tarifarios/index";

export const ModalPersonalizar = ({ isOpen, tratamientoBase, empresaId, onClose }) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [tarifario, setTarifario] = React.useState([]);
  const [item, setItem] = React.useState(tratamientoBase || {});
  const subGrupos = useSelector((state) => state.subGrupos);
  const [form, setForm] = useState({
    tratamiento: '',
    tipo: '',
    especialidad: '',
    precio: 0,
    costo: 0,
    tiempo: 30,
    id: '',
    origen: 'base',
    codTra: '',
  });

  useEffect(() => {
    if (tratamientoBase) {
      setForm({
        tratamiento: tratamientoBase.tratamiento || '',
        tipo: tratamientoBase.tipo || '',
        especialidad: tratamientoBase.especialidad || '',
        precio: tratamientoBase.precio ?? tratamientoBase.precioSugerido ?? 0,
        costo: tratamientoBase.costo ?? tratamientoBase.costoSugerido ?? 0,
        tiempo: tratamientoBase.tiempo ?? tratamientoBase.tiempoSugerido ?? 30,
        id: tratamientoBase.id,
        codTra: tratamientoBase.codTra || '',
        origen: tratamientoBase.origen,
        subGrupoId: tratamientoBase.subGrupoId || '',
        codLab: tratamientoBase.codLab || '',
      });
    }
  }, [tratamientoBase]);

  React.useEffect(() => {
      if (tarifario.length === 0)
        fetchTarifarios().then((tarifario) => {
          setTarifario(tarifario);
        });
    }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: ["precio", "costo", "tiempo"].includes(name) ? Number(value) : value,
    }));
  };

    const enviaLab = () => {
    if (tratamientoBase.subGrupoId == undefined) return false;
    const i = subGrupos.find((it) => it.id === tratamientoBase.subGrupoId);
    if (i) return i.envLab;
    else return false;
  };

  const handleGuardar = async () => {
    try {
      if (!empresaId) throw new Error("Empresa no definida");
      const personalizado = await dispatch(personalizarTratamientoBase(form, empresaId));
      addToast("Tratamiento personalizado", { appearance: "success" });
      onClose(personalizado);
    } catch (err) {
      addToast(err.message || "Error al personalizar", { appearance: "error" });
    }
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={() => onClose(null)}>

        <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>
          Personalizar Tratamiento
        </h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
          <div style={{ gridColumn: 'span 2' }}>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 'medium', marginBottom: '0.5rem' }}>
              Tratamiento
            </label>
            <input 
              disabled 
              value={form.tratamiento} 
              style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px' }} 
            />
          </div>
          
          <div>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 'medium', marginBottom: '0.5rem' }}>
              Tipo
            </label>
            <input
              name="tipo"
              value={form.tipo}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px' }}
            />
          </div>

           {enviaLab() && (
                        <div>
                          <label htmlFor="odonto" style={{ display: 'block', fontSize: '0.875rem', fontWeight: 'medium', marginBottom: '0.5rem' }}>Tratamiento Lab</label>
          
                          <select
                            name="codLab"
                            value={form.codLab}
                            onChange={handleChange }
                            style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px' }}
                          >
                            <option value="">Seleccione un tratamiento</option>
                            {tarifario.sort((a, b) => a.nombre.localeCompare(b.nombre)).map((it) => (
                              <option key={it.id} value={it.id}>{it.nombre}</option>
                            ))}
                          </select>
                        </div>
                      )}
          
          <div>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 'medium', marginBottom: '0.5rem' }}>
              Especialidad
            </label>
            <input 
              readOnly
              name="especialidad"
              value={form.especialidad}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px' }}
            />
          </div>
          
          <div>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 'medium', marginBottom: '0.5rem' }}>
              Precio
            </label>
            <input 
              name="precio"
              type="number"
              value={form.precio}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px' }}
            />
          </div>
          
          <div>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 'medium', marginBottom: '0.5rem' }}>
              Costo
            </label>
            <input 
              name="costo"
              type="number"
              value={form.costo}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px' }}
            />
          </div>
          
          <div style={{ gridColumn: 'span 2' }}>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 'medium', marginBottom: '0.5rem' }}>
              Tiempo (min)
            </label>
            <input 
              name="tiempo"
              type="number"
              value={form.tiempo}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px' }}
            />
          </div>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '24px' }}>
          <button 
            onClick={() => onClose(null)}
            style={{ 
              padding: '8px 16px', 
              border: '1px solid #d1d5db', 
              borderRadius: '4px',
              backgroundColor: '#f3f4f6',
              cursor: 'pointer'
            }}
          >
            Cancelar
          </button>
          <button 
            onClick={handleGuardar}
            style={{ 
              padding: '8px 16px', 
              backgroundColor: '#2563eb', 
              color: 'white',
              borderRadius: '4px',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            Guardar
          </button>
        </div>
        </Modal>
  );
};